"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateReferenceClusterAction = void 0;
const transferCluster_1 = require("./transferCluster");
function generateReferenceClusterAction(props) {
    if (props.referenceType === 'lockProxy') {
        return {
            actions: [],
            scriptInfos: [],
        };
    }
    if (!props.cluster) {
        throw new Error('Cannot generate TransferCluster Action without cluster info');
    }
    return (0, transferCluster_1.generateTransferClusterAction)({
        txSkeleton: props.txSkeleton,
        inputIndex: props.cluster.inputIndex,
        outputIndex: props.cluster.outputIndex,
    });
}
exports.generateReferenceClusterAction = generateReferenceClusterAction;
//# sourceMappingURL=referenceCluster.js.map